import { Link } from 'react-router-dom'

const Nav = () => {
  return (
    <div>
      <nav>
        <ul>
          <li>
            <Link to='/'>Home</Link>
          </li>
          <li>
            <Link to='/flight'>Flight Calculator</Link>
          </li>
          <li>
            <Link to='/car'>Car Journey Calculator</Link>
          </li>
          <li>
            <Link to='/about'>About</Link>
          </li>
        </ul>
      </nav>
    </div>
  )
}

export default Nav
